export const layeredColumnChartConstant = {
	title: 'title',
	value: 'value',
	maxValue: 'maxValue',
	color: {
		value: '#62BC7C',
		maxValue: '#DDDDDD',
	},
}
